import React from 'react';
import PropTypes from 'prop-types';
import Social from './Social';
import { getContextualUrl } from '../scripts/utils';
var defaultSecondaryLogo = {
  alt: 'Boys and Girls Club of America',
  link: 'https://www.bgca.org/about-us/our-partners/mlb',
  src: '//www.mlbstatic.com/mlb.com/builds/site-core/6ba79ea6e6d26980b58bc4c45f9688f6c41d1c8e_1551285135/images/bgca.svg'
};
var Sponsor = function Sponsor(_ref) {
  var hideSocial = _ref.hideSocial,
    locale = _ref.locale,
    isLegacy = _ref.isLegacy,
    secondaryLogo = _ref.secondaryLogo;
  var logoHref = getContextualUrl('/', undefined, locale, isLegacy);
  var _ref2 = secondaryLogo !== null && secondaryLogo !== void 0 && secondaryLogo.src ? secondaryLogo : defaultSecondaryLogo,
    _ref2$alt = _ref2.alt,
    alt = _ref2$alt === void 0 ? '' : _ref2$alt,
    link = _ref2.link,
    src = _ref2.src;
  var secondaryMedia = /*#__PURE__*/React.createElement("img", {
    alt: alt,
    "data-src": src,
    src: src,
    loading: "lazy"
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "site-footer__sponsor-container"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "site-footer__sponsor-image-container"
  }, /*#__PURE__*/React.createElement("li", {
    className: "site-footer__mlb-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: logoHref,
    "aria-label": "MLB.com"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "MLB.com",
    className: "p-logo mlb-logo",
    "data-src": "//www.mlbstatic.com/team-logos/league-on-dark/1.svg",
    src: "//www.mlbstatic.com/team-logos/league-on-dark/1.svg",
    loading: "lazy"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "site-footer__bgca-logo"
  }, link ? /*#__PURE__*/React.createElement("a", {
    href: link
  }, secondaryMedia) : secondaryMedia)), !hideSocial && /*#__PURE__*/React.createElement(Social, null));
};
export default Sponsor;
Sponsor.propTypes = {
  hideSocial: PropTypes.bool,
  locale: PropTypes.string,
  secondaryLogo: PropTypes.shape({
    alt: PropTypes.string,
    link: PropTypes.string,
    src: PropTypes.string.isRequired
  }),
  teamNameSlug: PropTypes.string,
  isLegacy: PropTypes.bool
};